import * as React from 'react';

const BgHexaflowPattern = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 361 201"
    fill="none">
    <mask
      id="a"
      width={353}
      height={201}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}>
      <path
        fill="#2961FA"
        d="M346.988.8H6.488a6 6 0 0 0-6 6v188.001a6 6 0 0 0 6 6h340.5a6 6 0 0 0 6-6v-188a6 6 0 0 0-6-6Z"
      />
    </mask>
    <g fillOpacity={0.05} mask="url(#a)">
      <path fill="#444" d="M23.219.242-6.506 50.838h59.45L23.219.242Z" />
      <path fill="#DDD" d="m142.117.242-29.724 50.596h59.449L142.117.242Z" />
      <path fill="#000" d="m201.566.242-29.725 50.596h59.449L201.566.242Z" />
      <path fill="#444" d="m261.019.242-29.725 50.596h59.449L261.019.242Z" />
      <path
        fill="#DDD"
        d="m320.467.242-29.725 50.596h59.45L320.467.242ZM23.219 101.438l-29.725 50.595h59.45l-29.725-50.595Z"
      />
      <path
        fill="#000"
        d="M23.219 101.435 52.944 50.84h-59.45l29.725 50.595Z"
      />
      <path
        fill="#666"
        d="m82.67 101.438-29.726 50.595h59.45l-29.725-50.595Z"
      />
      <path
        fill="#AAA"
        d="m82.67 101.435 29.724-50.595h-59.45l29.725 50.595Z"
      />
      <path
        fill="#DDD"
        d="m142.117 101.438-29.724 50.595h59.449l-29.725-50.595Z"
      />
      <path
        fill="#999"
        d="m142.117 101.435 29.725-50.595h-59.449l29.724 50.595ZM201.566 101.438l-29.725 50.595h59.449l-29.724-50.595Z"
      />
      <path
        fill="#fff"
        d="M201.566 101.435 231.29 50.84h-59.449l29.725 50.595Z"
      />
      <path
        fill="#000"
        d="m261.019 101.438-29.725 50.595h59.449l-29.724-50.595Z"
      />
      <path
        fill="#DDD"
        d="m261.019 101.435 29.724-50.595h-59.449l29.725 50.595Z"
      />
      <path
        fill="#AAA"
        d="m320.467 101.438-29.725 50.595h59.45l-29.725-50.595Z"
      />
      <path
        fill="#444"
        d="m320.467 101.435 29.725-50.595h-59.45l29.725 50.595Z"
      />
      <path
        fill="#DDD"
        d="m82.67 202.627 29.724-50.596h-59.45l29.725 50.596Z"
      />
      <path
        fill="#000"
        d="m142.117 202.627 29.725-50.596h-59.449l29.724 50.596Z"
      />
      <path
        fill="#444"
        d="m201.566 202.627 29.724-50.596h-59.449l29.725 50.596Z"
      />
      <path
        fill="#666"
        d="m261.019 202.627 29.724-50.596h-59.449l29.725 50.596Z"
      />
      <path fill="#222" d="m-6.506 50.84-29.724 50.595h59.449L-6.506 50.84Z" />
      <path
        fill="#fff"
        d="M-6.506 50.837 23.22.242h-59.45l29.725 50.596ZM52.945 50.84l-29.724 50.595h59.45L52.944 50.84Z"
      />
      <path fill="#666" d="M52.945 50.837 82.67.242H23.22l29.725 50.596Z" />
      <path
        fill="#222"
        d="m112.399 50.84-29.725 50.595h59.449L112.399 50.84Z"
      />
      <path fill="#fff" d="M112.399 50.837 142.123.242h-59.45L112.4 50.838Z" />
      <path fill="#444" d="m171.844 50.84-29.725 50.595h59.45L171.844 50.84Z" />
      <path fill="#222" d="M171.844 50.837 201.569.242h-59.45l29.725 50.596Z" />
      <path fill="#AAA" d="m231.292 50.84-29.725 50.595h59.45L231.292 50.84Z" />
      <path fill="#666" d="M231.292 50.837 261.017.242h-59.45l29.725 50.596Z" />
      <path
        fill="#fff"
        d="m290.745 50.84-29.724 50.595h59.449L290.745 50.84Z"
      />
      <path fill="#999" d="M290.745 50.837 320.47.242h-59.449l29.724 50.596Z" />
      <path
        fill="#000"
        d="m-6.506 152.031-29.724 50.596h59.449l-29.725-50.596Z"
      />
      <path
        fill="#666"
        d="m-6.506 152.033 29.725-50.595h-59.45l29.725 50.595Z"
      />
      <path
        fill="#AAA"
        d="m52.945 152.031-29.724 50.596h59.45l-29.726-50.596Z"
      />
      <path
        fill="#444"
        d="m52.945 152.033 29.725-50.595H23.22l29.725 50.595ZM112.399 152.031l-29.725 50.596h59.449l-29.724-50.596Z"
      />
      <path
        fill="#999"
        d="m112.399 152.033 29.724-50.595h-59.45l29.726 50.595Z"
      />
      <path
        fill="#666"
        d="m171.844 152.033 29.725-50.595h-59.45l29.725 50.595Z"
      />
      <path
        fill="#222"
        d="m231.292 152.031-29.725 50.596h59.45l-29.725-50.596Z"
      />
      <path
        fill="#fff"
        d="m290.745 152.031-29.724 50.596h59.449l-29.725-50.596Z"
      />
      <path
        fill="#222"
        d="m290.745 152.033 29.725-50.595h-59.449l29.724 50.595ZM350.189 50.84l-29.725 50.595h59.449L350.189 50.84Z"
      />
      <path
        fill="#fff"
        d="M350.189 50.837 379.913.242h-59.449l29.725 50.596Z"
      />
      <path
        fill="#000"
        d="m350.189 152.031-29.725 50.596h59.449l-29.724-50.596Z"
      />
      <path
        fill="#666"
        d="m350.189 152.033 29.724-50.595h-59.449l29.725 50.595Z"
      />
    </g>
  </svg>
);

export default BgHexaflowPattern;
